import { __BrandFilterType, __BrandSearchParamsType } from '../brandDetail.type';

export const __BrandRankingCheckFilterChange = (filters: __BrandFilterType, initialFilter: __BrandSearchParamsType) => {
    return filters.page === initialFilter.page;
};

export const __BrandRankingFetchParams = (e: __BrandFilterType, brand: string) => {
    const params: { [key: string]: number | string[] | string | boolean } = {
        page_size: 5,
        brand__slug__in: brand,
        is_active: true,
        order: '-created_at',
    };
    if (e.page) params.page = e.page;
    return params;
};
